function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { IconButton as MaterialIconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { defaultGreen, defaultGrey, defaultOrange, defaultRed } from "../../utils/colors";
import { buttonClassNameDefinition } from "./styles";
var useStyles = makeStyles({
  disabled: {
    color: defaultGrey
  },
  buttonColorSuccess: {
    color: defaultGreen
  },
  buttonColorWarning: {
    color: defaultOrange
  },
  buttonColorError: {
    color: defaultRed
  }
});
export var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      customVariant = _ref.customVariant,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["disabled", "customVariant", "children", "className"]);

  var classes = useStyles();
  var classdef = buttonClassNameDefinition(classes, false, customVariant);
  return /*#__PURE__*/React.createElement(MaterialIconButton, _extends({
    className: clsx(className, classdef),
    disabled: disabled
  }, props, {
    ref: ref
  }), children);
});
IconButton.defaultProps = {
  disabled: false,
  customVariant: undefined
};
IconButton.propTypes = {
  customVariant: PropTypes.oneOf(['success', 'warning', 'error']),
  disabled: PropTypes.bool
};
export default IconButton;